export default "__VITE_ASSET__CGXe6HGY__"